import {Logger} from '#/logger'

type Event<M extends Record<string, any>> = {
  source: 'app'
  time: number
  event: keyof M
  payload: M[keyof M]
  metadata: Record<string, any>
}

const logger = Logger.create(Logger.Context.Metric, {})

/**
 * Batesky: product-analytics telemetry is disabled. This client keeps the same
 * public API (`track`) so all `ax.metric(...)` call sites keep working, but it
 * NEVER transmits anything to `events.bsky.app`. Events are only written to the
 * local debug logger. To re-enable, restore the batching/`sendBatch` transport
 * from upstream social-app `src/analytics/metrics/client.ts`.
 */
export class MetricsClient<M extends Record<string, any>> {
  maxBatchSize = 100

  start() {
    // no-op: nothing to flush, nothing scheduled
  }

  track<E extends keyof M>(
    event: E,
    payload: M[E],
    metadata: Record<string, any> = {},
  ) {
    const e: Event<M> = {
      source: 'app',
      time: Date.now(),
      event,
      payload,
      metadata,
    }
    // Local-only: visible in dev logs, never sent over the network.
    logger.debug(`event: ${e.event as string}`, e)
  }

  flush() {
    // no-op
  }
}
